<template>
  <div class="parametres">
    <h2>Paramètres</h2>
    <br />
    <div class="card shadow mb-4">
      <!-- Card Header - Dropdown -->
      <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
        <h6 class="m-0 font-weight-bold text-primary">Personnalisation des paramètres</h6>
      </div>
      <!-- Card Body -->
      <div class="p-3">
        <table class="table table-responsive">
          <tr>
            <th>Code</th>
            <th>Libelle</th>
            <th>Valeur</th>
            <th></th>

          </tr>
          <tr v-for="parameter in allParameters" :key="parameter.Id">
            <td>{{ parameter.Code }}</td>
            <td>{{ parameter.Libelle }}</td>
            <td><input class="form-control" id="value" type="text" v-model="parameter.Valeur" /></td>
            <td><button type="button" id="btn-save" class="btn" v-on:click="updateParameters(parameter)">Enregistrer</button></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import { apiPost } from "@/utils";
  import { initParameters } from "@/utils/adminMapsMixin";

  export default {
    name: 'Parameters',
    data() {
      return {
        allParameters: []
      }
    },
    mounted() {
      this.initData();
    },
    methods: {
      initData() {
        initParameters().then(res => this.allParameters = res);
      },
      updateParameters(parameter) {
          apiPost("maps/parameters/update/byid?id=" + parameter.Id + "&value=" + parameter.Valeur)
          .then(e => {
            this.initData();
            alert("Sauvegarde effectuée avec succés");
            console.log(e);
          })
          .catch(e => {
            alert("Erreur de sauvegarde");
            console.log(e);
          });
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  div.parametres {
    width: 71%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Admin/AdminMaps/Parameters.vue